
<template>
    <aside class="sidebar">
        <router-link class="sidebar__logo-wrapper" :to="{ name: 'home' }"><SVGlogo-stacked class="sidebar__logo" exact /></router-link>
        <NavMain />
        <FooterContact />
    </aside>
</template>

<script>
export default {

}
</script>

